import {
  AnchorButton,
  Button,
  Classes,
  Drawer,
  Intent,
  Position,
} from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import { TEST_IDS } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';

type ProjectDiagramCreateEntityDrawerProps = {
  children: React.ReactNode;
  disabled: boolean;
  errorText: string;
  errorIntent: Intent;
  isOpen: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  title: string;
};

export const ProjectDiagramCreateEntityDrawer: React.VFC<
  ProjectDiagramCreateEntityDrawerProps
> = ({
  children,
  disabled,
  errorText,
  errorIntent,
  isOpen,
  onCancel,
  onSubmit,
  title,
}) => {
  return (
    <Drawer
      autoFocus={false}
      backdropClassName={classNames(
        'sd-drawer-project-diagram-entity__backdrop',
        'sd-drawer-project-diagram-create-entity__backdrop'
      )}
      canEscapeKeyClose={false}
      canOutsideClickClose={false}
      className={classNames(
        'sd-drawer-project-diagram-entity',
        'sd-drawer-project-diagram-create-entity'
      )}
      enforceFocus={false}
      hasBackdrop
      isOpen={isOpen}
      lazy={false}
      onClose={onCancel}
      position={Position.RIGHT}
      shouldReturnFocusOnClose={false}
      title={title}
      usePortal={false}
    >
      <div className={Classes.DRAWER_BODY}>{children}</div>
      <div className={Classes.DRAWER_FOOTER}>
        <div className="sd-drawer-footer-actions">
          <Button
            data-testid={TEST_IDS.projectDiagram.entityDrawer.cancelButton}
            intent={Intent.PRIMARY}
            onClick={onCancel}
            outlined
            text={copy.components.projectDiagram.createDrawers.cancelButton}
          />
          <Tooltip
            content={errorText}
            disabled={!errorText}
            intent={errorIntent}
          >
            <AnchorButton
              data-testid={TEST_IDS.projectDiagram.entityDrawer.createButton}
              disabled={disabled}
              intent={Intent.PRIMARY}
              onClick={onSubmit}
              text={copy.components.projectDiagram.createDrawers.createButton}
            />
          </Tooltip>
        </div>
      </div>
    </Drawer>
  );
};
